import React from "react"

import MLUSnackbar from "components/ui/mlusnackbar/mlusnackbar"
import { connect } from "react-redux"

import * as StorageAPI from "lib/core/storage.api"
import { t } from "./general-notification.i18n"

const STORAGE_KEY = "hideGeneralNotification"

interface GeneralNotificationProps {
  show: boolean
}

const GeneralNotification = ({ show }: GeneralNotificationProps) => {
  // If the value is set in the localStorage with a timestamp before this date,
  // it will be considered as not set.
  const MIN_NOTIFY_TIMESTAMP = "2025-10-07"

  const valueFromStorage =
    StorageAPI.find(STORAGE_KEY) === undefined ||
    Number(StorageAPI.find(STORAGE_KEY)) < Date.parse(MIN_NOTIFY_TIMESTAMP)

  const [visible, setVisible] = React.useState(valueFromStorage)

  const handleClose = (closeButtonClicked: boolean) => {
    if (closeButtonClicked) {
      setVisible(false)

      const timestamp = new Date().getTime().toString()
      StorageAPI.upsert(
        {
          key: STORAGE_KEY,
          value: timestamp,
        },
        { local: true },
      )
    }
  }

  return (
    <MLUSnackbar
      message={t("general-notification")}
      open={show && visible}
      onClose={handleClose}
      timeout={null}
      closable
    />
  )
}

export default connect(
  (state: {
    session: {
      user: { features: { flags: { showGeneralNotification: boolean } } }
    }
  }) => ({
    show: state.session.user?.features?.flags?.showGeneralNotification,
  }),
)(GeneralNotification)
